import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class PurchaseOrderService {

  // subjects
  PurchaseOrder: ReplaySubject<any> = new ReplaySubject(1);
  PurchaseOrderLineItem: ReplaySubject<any> = new ReplaySubject(1);

  // last
  private _lastPoId?: number;
  private _lastPoLineItemId?: number;

  // processing states
  private _poProcessing = false;
  private _poLineItemProcessing = false;

  // endpoints
  private _poEp = `${this._apiSvc.endpoints.inventory}/api/PoHead`;
  private _poLineItemEp = `${this._apiSvc.endpoints.inventory}/api/PoItem`;

  constructor(
    private _apiSvc: ApiService
  ) { }

  /**
   * Get purchase order by id
   * @param id
   */
  getPurchaseOrder(id: number): void {

    if (this._poProcessing) return;

    if (this._lastPoId && this._lastPoId !== id) {
      this.PurchaseOrder.next(null);
    }

    this._lastPoId = id;
    this._poProcessing = true;

    this._apiSvc.get(`${this._poEp}/${id}`)
      .subscribe((res: any) => {
        this._poProcessing = false;
        this.PurchaseOrder.next(res);
      }, () => {
        this._poProcessing = false;
      });

  }

  /**
   * Get purchase order line item by id
   * @param id
   */
  getPurchaseOrderLineItem(id: number): void {

    if (this._poLineItemProcessing) return;

    if (this._lastPoLineItemId && this._lastPoLineItemId !== id) {
      this.PurchaseOrderLineItem.next(null);
    }

    this._lastPoId = id;
    this._poLineItemProcessing = true;

    this._apiSvc.get(`${this._poLineItemEp}/${id}`)
      .subscribe((res: any) => {
        this._poLineItemProcessing = false;
        this.PurchaseOrderLineItem.next(res);
      }, () => {
        this._poLineItemProcessing = false;
      });


  }

}
